var domHelpers = require("../../../utils/dom_helpers"),
	utils = require("../../../utils/utils"),
	eventable = require("../../../utils/eventable"),
	gridResize = require("./grid_resize"),
	configurable = require("../configurable");

var Grid = function(parent, config, factory, gantt){
	this.$config = utils.mixin({}, config || {});
	this.$gantt = gantt;
	this.$parent = parent;
	configurable(this);
	eventable(this);
	this.$state = {};
};

Grid.prototype = {
	init: function(container){
		var gantt = this.$gantt;
		var gridAriaAttr = gantt._waiAria.gridAttrString();
		var gridDataAriaAttr = gantt._waiAria.gridDataAttrString();

		container.innerHTML = "<div class='gantt_grid' style='height:inherit;width:inherit;' "+gridAriaAttr+"></div>";
		this.$grid = container.childNodes[0];

		this.$grid.innerHTML = "<div class='gantt_grid_scale' "+
			gantt._waiAria.gridScaleRowAttrString()+"></div><div class='gantt_grid_data' "+gridDataAriaAttr+"></div>";

		this.$grid_scale = this.$grid.childNodes[0];
		this.$grid_data = this.$grid.childNodes[1];

		var attr = this.$getConfig()[this.$config.bind + "_attribute"];
		if(!attr && this.$config.bind){
			attr = this.$config.bind + "_id";
		}
		this.$config.item_attribute = attr || null;
		var layers = this._createLayerConfig();
		if(!this.$config.layers){
			this.$config.layers = layers;
		}

		var resizer = gridResize(this.$gantt, this);
		resizer.init();
		this._renderHeaderResizers = resizer.doOnRender;

		this._addLayers(this.$gantt);
		this.callEvent("onReady", []);
		//this.refresh();
	},
	setSize: function(width, height){
		this.$config.width = width + 1;
		this.$state.width = width;
		this.$state.height = height;
		var colsWidth = this._setColumnsWidth(this.$config.width);
		this.$config.width -= 1;

		var config = this.$getConfig();
		if(colsWidth !== width){
			config.grid_width = colsWidth;
			this.$config.width = colsWidth - 1;
		}

		var dataHeight = Math.max(this.$state.height - config.scale_height, 0);
		this.$grid_data.style.height = dataHeight + "px";
		this.refresh();
	},
	getSize: function(){

		var config = this.$getConfig();

		var store = this.$gantt.getDatastore(this.$config.bind);

		var contentHeight = store ? config.row_height * store.countVisible() : 0,
			contentWidth = this._getGridWidth();

		var size = {
			x: this.$state.width,
			y: this.$state.height,
			contentX: this.isVisible() ? contentWidth: 0,
			contentY: this.isVisible() ? (config.scale_height + contentHeight) : 0,
			scrollHeight: this.isVisible() ? contentHeight: 0,
			scrollWidth: this.isVisible() ? contentWidth : 0
		};

		return size;
	},
	refresh: function(){
		this._calculateGridWidth();
		this._renderGridHeader();
	},
	scrollTo: function(left, top){
		if(!this.isVisible())
			return;

		if (left*1 == left){
			this.$grid.scrollLeft = left;
			this.$state.scrollLeft = this.$grid.scrollLeft;
		}

		var config = this.$getConfig();
		if(top*1 == top){
			this.$grid_data.scrollTop = top;
			this.$state.scrollTop = this.$grid_data.scrollTop;
			if(config.smart_rendering && this.$grid_data.scrollTop !== top){
				this.$grid_data.scrollTop = top % config.row_height;
				this.$state.scrollTop = this.$grid_data.scrollTop;
			}
		}else{
			if(config.smart_rendering && this.$grid_data.scrollTop !== this.$state.scrollTop){
				this.$grid_data.scrollTop = this.$state.scrollTop % config.row_height;
			}
		}
	},
	getGridColumns: function(){
		var config = this.$getConfig();
		return config.columns;
	},
	isVisible: function(){
		if(this.$parent && this.$parent.$config){
			return !this.$parent.$config.hidden;
		}else{
			return this.$grid.offsetWidth;
		}
	},

	_createLayerConfig: function(){
		var gantt = this.$gantt;
		var self = this;
		var layers = [
			{
				renderer: gantt.$ui.layers.gridLine,
				container: this.$grid_data,
				filter: [function(){
					return self.isVisible();
				}]
			}
		];
		return layers;
	},

	_addLayers: function(gantt){
		if(!this.$config.bind)
			return;

		this._taskLayers = [];

		var self = this;

		var layers = this.$gantt.$services.getService("layers");
		var taskRenderer = layers.getDataRender(this.$config.bind);

		if(!taskRenderer){
			taskRenderer = layers.createDataRender({
				name: this.$config.bind,
				defaultContainer: function(){ return self.$grid_data;}
			});
		}

		var taskLayers = this.$config.layers;
		for(var i = 0; taskLayers && i < taskLayers.length; i++){
			var layer = taskLayers[i];
			layer.host = this;
			var bar_layer = taskRenderer.addLayer(layer);
			this._taskLayers.push(bar_layer);
		}
	},

	_clearLayers: function(gantt){
		var layers = this.$gantt.$services.getService("layers");
		var taskRenderer = layers.getDataRender(this.$config.bind);

		for(var i = 0; i < this._taskLayers.length; i++){
			taskRenderer.removeLayer(this._taskLayers[i]);
		}

		this._taskLayers = [];
	},

	_setColumnsWidth: function(newWidth){
		var config = this.$getConfig();
		var columns = this.getGridColumns(),
			columns_width = 0,
			final_width = newWidth;

		for (var i = 0, l = columns.length; i < l; i++) {
			columns_width += columns[i].width*1;
		}

		if(isNaN(columns_width)){
			this._calculateGridWidth();
		}
		columns_width = 0;
		for (var i = 0, l = columns.length; i < l; i++) {
			columns_width += columns[i].width*1;
		}

		var columns_count = columns.length,
			extra_width = final_width - columns_width;

		var colShare = 0;
		for (var i = 0; i < columns_count; i++) {
			var share = Math.floor(extra_width * (columns[i].width / columns_width));
			columns_width -= columns[i].width;
			colShare = columns[i].width + share;

			if ((columns[i].min_width && colShare >= columns[i].min_width) || !columns[i].min_width ||
				colShare > columns[i].width) {
				extra_width -= share;
				columns[i].width = colShare;
			}

		}

		var iterator = extra_width > 0 ? 1 : -1;
		while ((extra_width > 0 && iterator === 1) || (extra_width < 0 && iterator === -1)) {
			var curExtra = extra_width;
			for (i = 0; i < columns_count; i++) {
				var newWidth = columns[i].width + iterator;

				if ((columns[i].min_width && newWidth >= columns[i].min_width) || !columns[i].min_width ||
					colShare > columns[i].width) {
					extra_width -= iterator;
					columns[i].width = newWidth;
					if (!extra_width) {
						break;
					}
				}
			}
			if (curExtra == extra_width) {
				break;
			}
		}

		//if (this.callEvent("onGridResizeEnd", [config.grid_width, final_width]) === false)
		//	return;

		return final_width;
	},

	_getColsTotalWidth: function(){
		var columns = this.getGridColumns();
		var cols_width = 0;

		for (var i = 0; i < columns.length; i++) {
			var v = parseFloat(columns[i].width);
			if (window.isNaN(v)) {
				return false;
			}
			cols_width += v;
		}
		return cols_width;
	},
	_calculateGridWidth: function(){
		var config = this.$getConfig();
		var columns = this.getGridColumns();
		var cols_width = 0;
		var unknown = [];
		var width = [];

		for (var i = 0; i < columns.length; i++) {
			var v = parseFloat(columns[i].width);
			if (window.isNaN(v)) {
				v = 50;
				unknown.push(i);
			}
			width[i] = v;
			cols_width += v;
		}
		var gridWidth = this._getGridWidth();
		if (config.autofit || unknown.length) {
			var diff = gridWidth - cols_width;
			// TODO: logic may be improved for proportional changing of width
			var step = diff / (unknown.length > 0 ? unknown.length : (width.length > 0 ? width.length : 1));
			if (unknown.length > 0) {
				// there are several columns with undefined width
				var delta = diff / (unknown.length ? unknown.length : 1);
				for (var i = 0; i < unknown.length; i++) {
					var index = unknown[i];
					width[index] += delta;
				}
			} else {
				// delta must be added for all columns
				var delta = diff / (width.length ? width.length : 1);
				for (var i = 0; i < width.length; i++)
					width[i] += delta;
			}

			for (var i = 0; i < width.length; i++) {
				columns[i].width = width[i];
			}
		} else {
			var changed = (gridWidth != cols_width);
			this.$config.width = cols_width - 1;
			config.grid_width = cols_width;
			if(changed){
				this.$parent._setContentSize(this.$config.width, this.$config.height);
//				this.$parent.$config.width = cols_width;
			}
		}
	},

	_renderGridHeader: function(){
		var gantt = this.$gantt;
		var config = this.$getConfig();
		var locale = this.$gantt.locale;
		var templates = this.$gantt.templates;

		var columns = this.getGridColumns();
		var cells = [];
		var width = 0,
			labels = locale.labels;

		var lineHeigth = config.scale_height - 1;

		for (var i = 0; i < columns.length; i++) {
			var last = i == columns.length - 1;
			var col = columns[i];

			// ensure columns have non-empty names
			if (!col.name) {
				col.name = gantt.uid() + "";
			}

			var colWidth = col.width * 1;

			var gridWidth = this._getGridWidth();
			if (last && gridWidth > width + colWidth)
				col.width = colWidth = gridWidth - width;
			width += colWidth;
			var sort = (gantt._sort && col.name == gantt._sort.name) ? ("<div class='gantt_sort gantt_" + gantt._sort.direction + "'></div>") : "";
			var cssClass = ["gantt_grid_head_cell",
				("gantt_grid_head_" + col.name),
				(last ? "gantt_last_cell" : ""),
				templates.grid_header_class(col.name, col)].join(" ");

			var style = "width:" + (colWidth - (last ? 1 : 0)) + "px;";
			var label = (col.label || labels["column_" + col.name]);
			label = label || "";

			var ariaAttrs = gantt._waiAria.gridScaleCellAttrString(col, label);

			var cell = "<div class='" + cssClass + "' style='" + style + "' " + ariaAttrs + " column_id='" + col.name + "'>" + label + sort + "</div>";
			cells.push(cell);
		}
		this.$grid_scale.style.height = (config.scale_height) + "px";
		this.$grid_scale.style.lineHeight = lineHeigth + "px";
		this.$grid_scale.style.width = "inherit";
		this.$grid_scale.innerHTML = cells.join("");

		if(this._renderHeaderResizers){
			this._renderHeaderResizers();
		}
	},

	_getGridWidth: function(){
		return this.$config.width;
	},

	destroy: function(){
		this._clearLayers(this.$gantt);

		this.$grid = null;
		this.$grid_scale = null;
		this.$grid_data = null;
		this.$gantt = null;
		this.callEvent("onDestroy", []);
		this.detachAllEvents();
	}
};

module.exports = Grid;



//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/grid/grid.js
// module id = 39
// module chunks = 0